import { DateTime } from 'luxon';
import { Instance, flow, getParent, types } from 'mobx-state-tree';

import { removeMeetSlot } from '@common/api/meetSlots';

import { IReworkingSlotsModel } from './ReworkingSlots';
import { MIN_HOUR } from './constants';

const ReworkingSlot = types
	.model('ReworkingSlot', {
		id: types.identifierNumber,
		location: types.frozen(),
		service_id: types.number,
		student_id: types.maybeNull(types.number),
		end_dt: types.string,
		start_dt: types.string,
		status: types.maybeNull(types.number),
		teacher: types.maybeNull(types.frozen()),
		type: 'working_off',
	})
	.views((self) => ({
		get startDateTime() {
			return DateTime.fromSQL(self.start_dt);
		},
		get endDateTime() {
			return DateTime.fromSQL(self.end_dt);
		},
	}))
	.views((self) => ({
		get weekday(): number {
			return self.startDateTime.weekday;
		},
		get hourNumber(): number {
			return self.startDateTime.hour;
		},
		get hourSlotNumber(): number {
			const parent = getParent(self, 2) as IReworkingSlotsModel;
			return Math.floor(self.startDateTime.minute / parent.slotDuration);
		},
		get timesString() {
			return `${self.startDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)} - ${self.endDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)}`;
		},
		get lessonSlotNumber(): number {
			const parent = getParent(self, 2) as IReworkingSlotsModel;
			const minutes = (self.startDateTime.hour - MIN_HOUR) * 60 + self.startDateTime.minute;
			return Math.floor(minutes / parent.slotDuration) + 1;
		},
		get isOtherLocation(): boolean {
			const parent = getParent(self, 2) as IReworkingSlotsModel;
			return self.location.id !== parent.location_id;
		},
	}))
	.actions((self) => ({
		_fetch: () => {},
		remove: flow(function* () {
			yield removeMeetSlot(self.id);
			const parent = getParent(self, 2) as IReworkingSlotsModel;
			parent.removeSlot(self);
		}),
		setStatus(status: number, studentId?: number) {
			self.status = status;
			if (studentId || studentId === null) {
				self.student_id = studentId;
			}
		},
	}));

export default ReworkingSlot;

export interface IReworkingSlotModel extends Instance<typeof ReworkingSlot> {}
